import { createContext, useContext, useEffect, useMemo, useState } from "react";

const PresentationContext = createContext({ presenting: false, toggle: () => {} });

export const PresentationProvider = ({ children }) => {
  const [presenting, setPresenting] = useState(
    () => localStorage.getItem("aikyam_presentation") === "1"
  );

  useEffect(() => {
    localStorage.setItem("aikyam_presentation", presenting ? "1" : "0");
  }, [presenting]);

  const value = useMemo(
    () => ({ presenting, toggle: () => setPresenting((v) => !v) }),
    [presenting]
  );
  return <PresentationContext.Provider value={value}>{children}</PresentationContext.Provider>;
};

export const usePresentation = () => useContext(PresentationContext);
